
import { createReducer, on } from "@ngrx/store";
import { FetchUsersState } from "src/app/common/models/user-management.model";
import { FetchUsersActions } from "./fetch-user.index";
// import { error } from "ajv/dist/vocabularies/applicator/dependencies";

export const initialState: FetchUsersState = {
    data: null,
    isLoading: false,
    error: null
}

export const FetchUsersReducer = createReducer(
    initialState,
    on(FetchUsersActions.fetchUsers, (state): FetchUsersState => ({
        ...state,
        data: null,
        isLoading: true,
        error: null
    })),
    on(FetchUsersActions.fetchUsersSuccess, (state, { response }): FetchUsersState => ({
        ...state,
        data: response,
        isLoading: false,
        error: null
    })),
    on(FetchUsersActions.fetchUsersError, (state, { error }): FetchUsersState => ({
        ...state,
        isLoading: false,
        error
    }))
)
